import styled from "styled-components";
import colours from "../assets/colours";

export const PageWrapper = styled.div`
  background-color: ${colours.blue};
  height: 100%;
  color: white;
  overflow: auto;
`;

export const PageContainer = styled.div`
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 20px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const Banner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  margin-bottom: 40px;
`;

export const Paragraph = styled.p`
  margin: 0;
  padding: 0 0 10px 0;
  font-size: 18px;
`;

export const SubHeading = styled.h2`
  margin: 0;
  padding: 0 0 10px 0;
  font-size: 28px;
  font-weight: 200;
`;

export const Input = styled.input`
  width: 100%;
  padding: 15px 20px;
  margin: 0 0 20px 0;
  border: 1px solid #fff;
  background-color: rgba(255, 255, 255, 0);
  border-radius: 40px;
  color: #fff;
  font-size: 20px;
  outline: none;
  transition: 0.2s;
  box-sizing: border-box;
  text-align: center;
  letter-spacing: 2px;
  &:focus {
    background-color: rgba(255, 255, 255, 0.1);
  }
  &::placeholder {
    color: #bbc2d3;
    opacity: 1; /* Firefox */
  }
  &[type="password"] {
    letter-spacing: 12px;
    &::placeholder {
      letter-spacing: 2px;
    }
  }
`;

export const InputSmall = styled.input`
  width: 100%;
  padding: 15px 20px;
  margin: 0 0 20px 0;
  border: 1px solid ${colours.blue};
  background-color: rgba(255, 255, 255, 0);
  border-radius: 40px;
  color: ${colours.blue};
  font-size: 20px;
  outline: none;
  transition: 0.2s;
  box-sizing: border-box;
  text-align: center;
  letter-spacing: 2px;
  &:focus {
    background-color: rgba(255, 255, 255, 0.1);
  }
  &::placeholder {
    color: #bbc2d3;
    opacity: 1; /* Firefox */
  }
  &[type="password"] {
    letter-spacing: 12px;
    &::placeholder {
      letter-spacing: 2px;
    }
  }
`;

export const ButtonWO = styled.button`
  padding: 15px 50px;
  border: 1px solid #fff;
  background-color: rgba(255, 255, 255, 0);
  border-radius: 40px;
  color: #fff;
  font-size: 20px;
  outline: none;
  transition: 0.2s;
  cursor: pointer;
  &:hover {
    background-color: rgba(255, 255, 255, 0.2);
  }
`;

export const ButtonSmallWO = styled.button`
  padding: 10px 30px;
  border: 1px solid #fff;
  background-color: rgba(255, 255, 255, 0);
  border-radius: 40px;
  color: #fff;
  font-size: 18px;
  outline: none;
  transition: 0.2s;
  cursor: pointer;
  &:hover {
    background-color: rgba(255, 255, 255, 0.2);
  }
`;

export const ButtonSmallBlue = styled.button`
  padding: 10px 30px;
  border: 1px solid ${colours.blue};
  background-color: rgba(255, 255, 255, 0);
  border-radius: 40px;
  color: ${colours.blue};
  font-size: 18px;
  outline: none;
  transition: 0.2s;
  cursor: pointer;
  &:hover {
    background-color: rgba(255, 255, 255, 0.2);
  }
`;

export const ErrorText = styled.p`
  color: #ff3939;
  font-size: 12px;
  margin: 10px 0;
  background-color: #182b5e;
  padding: 4px 2px;
  border-radius: 2px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.3);
`;

export const Modal = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 100;
`;

export const ModalContent = styled.div`
	background-color: white;
	padding: 20px;
	border-radius: 20px;
	box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
	text-align: center;
`;